import Vue from "vue";
import VueRouter from "vue-router";
import { getStore, removeStore } from "@/store/storage";
import { Dialog } from 'vant';
import store from "@/store/index.js";

// import getValueSetCode from "@/request/value-set";
const TabBar = () =>
  import(/* webpackChunkName: "TabBar" */ "@/components/TabBar");
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Main",
    component: () => import("views/login/Login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () =>
      import(/* webpackChunkName: "Home" */ "views/registered/register.vue"),
    // meta: { requiresAuth: true, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail']},
    meta: { requiresAuth: false, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail'] },
  },
  {
    path: "/authentication",
    name: "authentication",
    component: () =>
      import(/* webpackChunkName: "Home" */ "views/registered/authentication.vue"),
    // meta: { requiresAuth: true, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail']},
    meta: { requiresAuth: false, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail'] },
  },
  {
    path: "/authenticationsucceeded",
    name: "authenticationsucceeded",
    component: () =>
      import(/* webpackChunkName: "Home" */ "views/registered/authenticationsucceeded.vue"),
    // meta: { requiresAuth: true, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail']},
    meta: { requiresAuth: false, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail'] },
  },
  {
    path: "/tabbar",
    name: "Tabbar",
    component: TabBar,
    children: [
      {
        path: "/Home",
        name: "Home",
        component: () =>
          import(/* webpackChunkName: "Home" */ "views/home/Home.vue"),
        // meta: { requiresAuth: true, keepAlive: false, cacheWhenFromRoutes: ['MessageDetail']},
        meta: { requiresAuth: false, keepAlive: true },
      },
      {
        path: "/organization",
        name: "Organization",
        component: () =>
          import(/* webpackChunkName: "Organization" */ "views/organization/index.vue"),
        meta: { requiresAuth: false, keepAlive: false },
      },
      {
        path: "/organization/company/list",
        name: "Company",
        component: () =>
          import(/* webpackChunkName: "Organization" */ "views/organization/company/list.vue"),
        meta: { requiresAuth: false, keepAlive: false },
      },
      {
        path: "/organization/company/detail",
        name: "Store",
        component: () =>
          import(/* webpackChunkName: "Organization" */ "views/organization/company/detail.vue"),
        meta: { requiresAuth: false, keepAlive: false },
      },
      {
        path: "/dayPlan",
        name: "DayPlan",
        component: () =>
          import(/* webpackChunkName: "DayPlan" */ "views/dayPlan/index.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "/messagelist",
        name: "MessageList",
        component: () => import("views/messageList/index.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/personal",
        name: "Personal",
        component: () =>
          import(
            /* webpackChunkName: "Personal" */ "views/mine/personal/Personal.vue"
          ),
        meta: { requiresAuth: true },
      },
      // 我的订单
      {
        path: "/order",
        name: "Order",
        component: () => import("views/order/orderList/Order.vue"),
        meta: { requiresAuth: true, keepAlive: false},
      },
    ],
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "@/views/About.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/resetPassword",
    name: "ResetPassword",
    component: () => import("views/mine/personal/ResetPassword.vue"),
  },
  {
    path: "/resetPasswordTwo",
    name: "ResetPasswordTwo",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/personal/ResetPasswordTwo.vue"
      ),
  },
  {
    path: "/updatePhoneNumber",
    name: "UpdatePhoneNumber",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/personal/UpdatePhoneNumber.vue"
      ),
    props: (route) => ({
      mobile: route.query.mobile,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: "/updatePhoneNumberTwo",
    name: "UpdatePhoneNumberTwo",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/personal/UpdatePhoneNumberTwo.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/updatePassword",
    name: "UpdatePassword",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/personal/UpdatePassword.vue"
      ),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("views/login/Login.vue"),
  },
  // 设置
  {
    path: "/setUp",
    name: "SetUp",
    component: () => import("views/mine/personal/SetUp.vue"),
  },
  // 关于我们
  {
    path: "/aboutUs",
    name: "AboutUs",
    component: () => import("views/mine/personal/AboutUs.vue"),
  },
  // 用户协议
  {
    path: "/userAgreement",
    name: "UserAgreement",
    component: () =>import( "views/mine/personal/UserAgreement.vue" ),
  },
  {
    path: "/personalInfoMaintenance",
    name: "personalInfoMaintenance",
    component: () => import("views/mine/personal/PersonalInfoMaintenance.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },

  // 我的公司
  {
    path: "/companyInformation",
    name: "CompanyInformation",
    component: () => import("views/mine/company/CompanyInformation.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 我的关注列表
  {
    path: "/attention",
    name: "attention",
    component: () => import("views/mine/attention/attention.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 提货人列表 
  {
    path: "/deliveryPersonList",
    name: "DeliveryPersonList",
    component: () => import("views/mine/company/DeliveryPersonList.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 车辆 VehicleList
  {
    path: "/vehicleList",
    name: "VehicleList",
    component: () => import("views/mine/company/VehicleList.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 车船详情
  {
    path: "/vehicleDetil",
    name: "vehicleDetil",
    component: () => import("views/mine/company/vehicleDetil.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 发票管理 Invoice
  {
    path: "/invoice",
    name: "Invoice",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/invoice/Invoice.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 专家服务质询列表
  {
    path: "/services",
    name: "services",
    component: () =>
      import(
        "views/mine/services/expert-services.vue"
      )
  },
  // 专家服务质询列表
  {
    path: "/servicesDetail",
    name: "servicesDetail",
    component: () =>
      import(
        "views/mine/services/expert-services-detail.vue"
      )
  },
  // 承运商管理  carrier
  {
    path: "/carrier",
    name: "carrier",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/carrier/carrier.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 承运商管理详情  carrierDetil
  {
    path: "/carrierDetil",
    name: "carrierDetil",
    component: () =>
      import(
          /* webpackChunkName: "personal" */ "views/mine/carrier/carrierDetil.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 往来账确认书 
  {
    path: "/currentAccountConfirmation",
    name: "CurrentAccountConfirmation",
    component: () => import("views/mine/currentAccountConfirmation/CurrentAccountConfirmation.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 客存查询 GuestDeposit
  {
    path: "/guestDeposit",
    name: "GuestDeposit",
    component: () => import("views/mine/guestDeposit/GuestDeposit.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 提货单列表
  {
    path: "/pickupApplication",
    name: "PickupApplication",
    component: () => import("views/mine/pickupApplication/PickupApplication.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/Pickuplogistics",
    name: "Pickuplogistics",
    component: () => import("views/mine/pickupApplication/Pickuplogistics.vue")
  },
  // 提货单详情
  {
    path: "/pickupDetail",
    name: "PickupDetail",
    component: () => import("views/mine/pickupApplication/PickupDetail.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },

  // 物流跟踪 
  {
    path: "/logisticsTracking",
    name: "LogisticsTracking",
    component: () => import("views/mine/pickupApplication/LogisticsTracking.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/news",
    name: "News",
    component: () => import("views/mine/personal/News.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 合同 
  {
    path: "/contract",
    name: "Contract",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/contract/Contract.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 合同详情
  {
    path: "/contractDetail",
    name: "ContractDetail",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/contract/ContractDetail.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 预览合同 ViewContract
  {
    path: "/viewContract",
    name: "ViewContract",
    component: () => import("views/mine/contract/ViewContract.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },

  // 资金管理 FundInquiry
  {
    path: "/fundInquiry",
    name: "FundInquiry",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/funds/FundInquiry.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 我的资质 QualificationList
  {
    path: "/qualificationList",
    name: "QualificationList",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/qualification/QualificationList.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 资质详情
  {
    path: "/qualificationDetails",
    name: "QualificationDetails",
    component: () =>
      import(
        /* webpackChunkName: "personal" */ "views/mine/qualification/QualificationDetails.vue"
      ),
    meta: { requiresAuth: true, keepAlive: false },
  },

  // 质检单
  {
    path: "/quality",
    name: "QualityInspectionForm",
    component: () => import("views/qualityInspectionForm/QualityInspectionForm.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 质检单详情 
  {
    path: "/qualityInspectionDetails",
    name: "QualityInspectionDetails",
    component: () => import("views/qualityInspectionForm/QualityInspectionDetails.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 计划销售
  {
    path: "/planSale",
    name: "PlanSaleList",
    component: () => import("views/planSale/PlanSaleList.vue"),
    meta: { requiresAuth: false, keepAlive: true },
  },
  {
    path: "/topProd",
    name: "TopProdList",
    component: () => import("views/planSale/TopProdList.vue"),
    meta: { requiresAuth: false, keepAlive: false },
  },
  // 计划销售 详情PlanSaleDetails
  {
    path: "/planSaleDetails",
    name: "PlanSaleDetails",
    component: () => import("views/planSale/PlanSaleDetails.vue"),
    meta: { requiresAuth: false, keepAlive: false },
  },
  // 查看MSDS 
  {
    path: "/viewMSDS",
    name: "ViewMSDS",
    component: () => import("views/planSale/view.vue"),
    // meta: { requiresAuth: true },
  },
  // 计划销售 订单确认 
  {
    path: "/planSale/OrderSubmit",
    name: "OrderSubmit",
    component: () => import("views/planSale/OrderSubmit.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 我的订单
  {
    path: "/order",
    name: "Order",
    component: () => import("views/order/orderList/Order.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/submitOrder",
    name: "SubmitOrder",
    component: () => import("views/order/submitOrder/SubmitOrder.vue"),
    props: (route) => ({
      id: route.query.id,
      purchaseVolume: route.query.purchaseVolume,
      stations: route.query.stations,
    }),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/submitOrderLng",
    name: "SubmitOrderLng",
    component: () => import("views/order/submitOrder/SubmitOrderLng.vue"),
    props: (route) => ({
      id: route.query.id,
      purchaseVolume: route.query.purchaseVolume,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: "/viewAgreement",
    name: "ViewAgreement",
    component: () => import("views/order/orderList/viewAgreement.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 查看协议

  // 评价
  {
    path: "/comment",
    name: "Comment",
    component: () => import("views/order/comment/Comment.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/orderDetail",
    name: "OrderDetail",
    component: () => import("views/order/orderDetail/OrderDetail.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 客户投诉列表
  {
    path: "/complaintList",
    name: "ComplaintList",
    component: () => import("views/complaint/ComplaintList.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 客户投诉新增 
  {
    path: "/addComplaint",
    name: "AddComplaint",
    component: () => import("views/complaint/AddComplaint.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  // 客户投诉详情 
  {
    path: "/complaintDetail",
    name: "ComplaintDetail",
    component: () => import("views/complaint/ComplaintDetail.vue"),
    meta: { requiresAuth: true, keepAlive: false },
  },
  {
    path: "/commodity",
    name: "Commodity",
    component: () =>
      import(/* webpackChunkName: "Commodity" */ "views/commodity/index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/commoditydetail",
    name: "CommodityDetail",
    component: () =>
      import(
        /* webpackChunkName: "Commodity" */ "views/commodityDetail/index.vue"
      ),
    props: (route) => ({
      id: route.query.id,
    }),
    meta: { requiresAuth: true },
  },
  {
    path: "/messagedetail",
    name: "MessageDetail",
    component: () => import("views/messageDetail/index.vue"),
    // props: (route) => ({
    //   id: route.query.id,
    // }),
    meta: { requiresAuth: false },
  },
  {
    path: "/viewAgreement",
    name: "ViewAgreement",
    component: () => import("views/agreement/Agreement.vue"),
    props: (route) => ({
      agreementType: route.query.agreementType,
      templateId: route.query.templateId,
    }),
    meta: { requiresAuth: true },
  },
  // 竞拍
  {
    path: "/auction",
    name: "Auction",
    component: () => import("views/auction/auction-index.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/auction-detail",
    name: "Auction",
    component: () => import("views/auctionDetail/auction-detail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/auction-notice",
    name: "Auction",
    component: () => import("views/auction/auction-notice.vue"),
    meta: { requiresAuth: true },
  },
  // 现货
  {
    path: "/matchup",
    name: "Matchup",
    component: () => import("views/matchup/matchup.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/matchup-detail",
    name: "Matchup",
    component: () => import("views/mathDetail/match-detil.vue")
  },
  // 闪购列表
  {
    path: "/flashSale",
    name: "FlashSaleList",
    component: () => import("views/flashSale/FlashSaleList.vue"),
    meta: { requiresAuth: true },
  },
  // 闪购商品详情
  {
    path: "/flashSaleDetail",
    name: "FlashSaleDetail",
    component: () => import("views/flashSale/FlashSaleDetail.vue"),
    meta: { requiresAuth: true },
  },
  // 拼单列表
  {
    path: "/groupBuy",
    name: "GroupBuyList",
    component: () => import("views/groupBuy/GroupBuyList.vue"),
    meta: { requiresAuth: true },
  },
  // 拼单商品详情
  {
    path: "/groupBuyDetail",
    name: "GroupBuyDetail",
    component: () => import("views/groupBuy/GroupBuyDetail.vue"),
    meta: { requiresAuth: true },
  },
  // 月度需求列表
  {
    path: "/requirementManage",
    name: "RequirementList",
    component: () => import("views/requirementManage/RequirementList.vue"),
    meta: { requiresAuth: true },
  },
  // 销售计划列表
  {
    path: "/salePlan",
    name: "salePlanList",
    component: () => import("views/salePlan/salePlanList.vue"),
    meta: { requiresAuth: true },
  },
  // 销售计划详情
  {
    path: "/salePlanDetail",
    name: "salePlanDetail",
    component: () => import("views/salePlan/salePlanDetail.vue"),
    meta: { requiresAuth: true },
  },
  // 月度需求详情
  // {
  //   path: "/groupBuyDetail",
  //   name: "GroupBuyDetail",
  //   component: () =>import("views/groupBuy/GroupBuyDetail.vue"),
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/test",
    name: "Test",
    component: () => import("views/test.vue"),
  },
  //购物车
  {
    path: "/cart",
    name: "Cart",
    component: () => import("views/order/cart/cart.vue"),
  },

];

const router = new VueRouter({
  routes,
});

//设置路由导航拦截：
router.beforeEach((to, from, next) => {
  let loginPage = ["/login", "/"];
  if (
    (to.name === 'Home' &&
      !(from.name === 'MessageDetail')
    ) ||
    (
      !(to.name === 'MessageDetail') &&
      from.name === 'Home')
  ) {
    sessionStorage.setItem('posy', 0)
  }
  let token = getStore("token");
  if (loginPage.indexOf(to.path) != -1) {
    removeStore("token");
    removeStore("userInfo");
    next();
    return;
  }

  if (!token && to.meta.requiresAuth == true) {
    if (store.state.from == 'seller') {
      Dialog.alert({
        title: "提示",
        message: "请先登录，再查看相关信息！"
      }).then(() => {
      });
      return;
    }
    Dialog.confirm({
      title: "提示",
      message: "请先登录，再查看相关信息！"
    }).then(() => {
      next({
        path: "/login",
      });
    }).catch(() => {
    })
    return;
  }
  next();
});

// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   if (isChunkLoadFailed) {
//     router.replace(targetPath);
//   }
// });

export default router;
